import React, { useState } from "react";
import axios from "axios";

const SendOTP = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState(null);
  const [message, setMessage] = useState("");

  const studentNumbers = ["8383023265", "9223456789"]; // Example student numbers

  // Generate a random 6-digit OTP
  const generateOTP = () => Math.floor(100000 + Math.random() * 900000);

  const sendOtpHandler = async () => {
    if (!studentNumbers.includes(mobile)) {
      setMessage("This number is not registered as a student.");
      return;
    }

    const otpCode = generateOTP();
    setOtp(otpCode);

    const url = "http://bulkpush.digimate/BULK_API/SendMessage";
    const params = {
      loginID: "your_username",
      password: "your_password",
      mobile: mobile,
      text: `Your OTP is ${otpCode}. Do not share it with anyone.`,
      senderid: "YOUR_SENDER_ID",
      route_id: "YOUR_ROUTE_ID",
      Unicode: "0",
      camp_name: "OTP_VERIFICATION",
      DLT_PE_ID: "YOUR_DLT_PE_ID",
      DLT_TM_ID: "YOUR_DLT_TM_ID",
      DLT_CT_ID: "YOUR_DLT_CT_ID",
    };

    try {
      const response = await axios.get(url, { params });
      if (response.data.status === "SUCCESS") {
        setMessage(`OTP sent successfully to ${mobile}`);
      } else {
        setMessage("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      setMessage("Error sending OTP. Check your API credentials.");
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg shadow-md max-w-sm mx-auto">
      <h2 className="text-xl font-semibold mb-4">Send OTP</h2>
      <input
        type="text"
        placeholder="Enter student mobile number"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
        className="p-2 border rounded w-full mb-3"
      />
      <button
        onClick={sendOtpHandler}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        Send OTP
      </button>
      {message && <p className="mt-3 text-gray-700">{message}</p>}
    </div>
  );
};

export default SendOTP;
